var generateStyle = function generateStyle(componentTheme) {
  return {
    wrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      marginTop: componentTheme.wrapperMargin
    },
    hero: {
      width: '100%',
      textAlign: 'center',
      fontSize: componentTheme.heroFontSize,
      color: componentTheme.heroColor
    },
    textWrapper: {
      width: '100%',
      textAlign: 'center',
      marginBottom: componentTheme.textWrapperMargin,
      color: componentTheme.textWrapperColor
    },
    title: {
      textAlign: 'center',
      fontSize: componentTheme.titleFontSize,
      margin: componentTheme.titleMargin
    },
    subtitle: {
      textAlign: 'center',
      fontSize: componentTheme.subtitleFontSize
    },
    buttonWrapper: {
      margin: componentTheme.buttonWrapperMargin,
      textAlign: 'center',
      width: '100%'
    }
  };
};
export default generateStyle;